@if ((isTranslationsLoading$ | async) === false) {
<div id="logout-component">
  <div class="logout">
    <button id="logout-button" mat-menu-item (click)="logout()">
      <mat-icon>logout</mat-icon>
      <span>{{ translationService.translate('logoutButtonText') }}</span>
    </button>
  </div>
</div>
}
